import styled from "styled-components";

interface SpacerProps {
  m?: string;
  mt?: string;
  mb?: string;
  ml?: string;
  mr?: string;
  mx?: string;
  my?: string;
}

const Spacer = styled.div`
  ${(props: SpacerProps) => props.m && `margin: ${props.m}`};
  ${(props: SpacerProps) => props.my && `margin-top: ${props.my}`};
  ${(props: SpacerProps) => props.my && `margin-bottom: ${props.my}`};
  ${(props: SpacerProps) => props.mt && `margin-top: ${props.mt}`};
  ${(props: SpacerProps) => props.mb && `margin-bottom: ${props.mb}`};
  ${(props: SpacerProps) => props.mx && `margin-left: ${props.mx}`};
  ${(props: SpacerProps) => props.mx && `margin-right: ${props.mx}`};
  ${(props: SpacerProps) => props.ml && `margin-left: ${props.ml}`};
  ${(props: SpacerProps) => props.mr && `margin-right: ${props.mr}`};
`;

export default Spacer;
